
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
});
